module.exports = "/_next/static/images/7409153fe0903c0ed29ebf1019a92ebf-iPhone12pro_1.png";